import Icon                 from 'components/Icon/Icon.react';
import React                from 'react';
import history from 'dashboard/history';
import PropTypes from 'prop-types';
import Button               from 'components/Button/Button.react';
import Tabs                 from 'components/Tabs/Tabs.react';
import CodeSnippet          from 'components/CodeSnippet/CodeSnippet.react';
import Field                from 'components/Field/Field.react';
import Label                from 'components/Label/Label.react';
import KeyField             from 'components/KeyField/KeyField.react';
import styles               from './sdkInfo.scss';
import ParseApp             from 'lib/ParseApp';

import {
  swift,
  objectivec,
  java,
  csharp,
  javascript,
  php,
  c
} from 'lib/Constants';

const code =
[{
  name: 'Swift',
  lang: 'swift',
  icon: 'ios',
  downloadLabel: 'iOS, OS X, watchOS and tvOS',
  downloadLink: 'https://github.com/ParsePlatform/Parse-SDK-iOS-OSX/releases',
  source: swift,
  desc: 'First of all, you have to install the latest version of the Parse SDK for <strong>iOS</strong>, <strong>OS X</strong>, <strong>watchOS</strong> or <strong>tvOS</strong>. You can download it here depending on the platform you are using to develop:'
}, {
  name: 'Objective C',
  lang: 'objectivec',
  icon: 'ios',
  downloadLabel: 'iOS, OS X, watchOS and tvOS',
  downloadLink: 'https://github.com/ParsePlatform/Parse-SDK-iOS-OSX/releases/latest',
  source: objectivec,
  desc: ''
}, {
  name: 'Java',
  lang: 'java',
  icon: 'android',
  downloadLabel: 'Android',
  downloadLink: 'https://github.com/parse-community/Parse-SDK-Android/releases/latest',
  source: java,
  desc: ''
}, {
  name: '.NET',
  lang: 'dotNetKey',
  icon: 'winrt',
  downloadLabel: '.NET',
  downloadLink: 'https://github.com/parse-community/Parse-SDK-dotNET/releases/latest',
  source: csharp,
  desc: ''
}, {
  name: 'JavaScript',
  lang: 'javascript',
  icon: 'js',
  downloadLabel: 'Javascript',
  downloadLink: 'https://github.com/parse-community/Parse-SDK-JS/releases/latest',
  source: javascript,
  desc: ''
}, {
  name: 'PHP',
  lang: 'php',
  icon: 'php',
  downloadLabel: 'PHP',
  downloadLink: 'https://github.com/ParsePlatform/parse-php-sdk/releases',
  source: php,
  desc: ''
}];

export default class sdkInfo extends React.Component {
  constructor() {
    super();
    this.state = {
      current: 0,
    }

    this.handleGoToURLClick = this.handleGoToURLClick.bind(this);
  }

  handleClick(url) {
    window.open(url, '_blank');
  }

  handleGoToURLClick(value) {
    history.push(`/products/apps/${this.context.currentApp.slug}/${value}`);
  }

  render() {

    let labels = [];
    let lang = [];
    let desc = [];

    for (let i in code) {
      labels.push(code[i].name)
      lang.push(code[i].name)
      desc.push(code[i].desc)
    }

    let sdks = (
      <Tabs
        labels={labels}
        values={lang}
        current={this.state.current}
        onChange={(current) => this.setState({ current })} />
    );

    let currentLang = code[this.state.current];

    return (
      <div className={styles.box}>
        <div className={styles.section}>
          <h1>Connect Applications with SashiDo</h1>
          <p>
            SashiDo allows you to easily run your app without significant changes on integration.<br />
            You just have to go through few simple steps and start your exciting journey with SashiDo!
          </p>
        </div>

        {sdks}

        <div className={styles.boxContent}>
          <div className={styles.desc}>
            <p>
              1. First of all, you have to install the latest version of the Parse SDK for <strong>{currentLang.downloadLabel}</strong>.
            </p>

            <div className={styles.download}>
              <Button
                primary={true}
                value={'Download Parse SDK for ' + currentLang.downloadLabel}
                iconSize={28}
                icon={'icon-logo-' + currentLang.icon}
                colored={true}
                onClick={this.handleClick.bind(this, currentLang.downloadLink)} />
            </div>

            <div className={styles.hr} />

            <Field
              fieldPadding={'0 0 0 0'}
              label={<Label text='2. Then you have to update your custom API URL (as the example below)' />}
              input={<KeyField>{this.props.app.serverURL}</KeyField>} />
          </div>

          <div className={styles.code}>
            <CodeSnippet source={currentLang.source(this.props.app)} fullPage={false} language={currentLang.lang} copy={true} />
          </div>
        </div>
      </div>
    );
  }
}

sdkInfo.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};
